// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".timeline-container {\n    align-content: stretch;\n    height: 100%;\n  }\n\n  .form-title {\n    font-weight: 600;\n    font-size: 125%;\n  }", ""]);
// Exports
module.exports = exports;
